import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId } from "@/App";
import BrandMark from "./BrandMark";

const LINKS = [
  ["Demo", "demo"],
  ["Aria Live", "aria-live"],
  ["Technology", "technology"],
  ["Investment", "investment"],
  ["Contact", "contact"],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "border-b border-white/10 bg-black/70 backdrop-blur-2xl" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-6 lg:px-10">
        <button
          data-testid="nav-logo"
          onClick={() => go("home")}
          className="flex items-center gap-2.5 sm:gap-3"
          aria-label="AIROBOTCAMSTUDIO — back to homepage"
        >
          <BrandMark className="h-10 w-10 rounded-md sm:h-9 sm:w-9" testid="nav-logo-mark" />
          <span className="font-display text-[13px] font-semibold tracking-[0.25em] text-white sm:text-sm">
            AIROBOTCAM<span className="text-cyan-300">STUDIO</span>
          </span>
        </button>

        <div className="ml-8 hidden items-center gap-4 xl:flex">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => go(id)}
              className="whitespace-nowrap text-xs font-medium tracking-wide text-cyan-200/70 transition-colors duration-300 hover:text-cyan-100"
            >
              {label}
            </button>
          ))}
          <a
            href="/register"
            data-testid="nav-register-cta"
            className="whitespace-nowrap rounded-md border border-cyan-300/30 px-4 py-2 text-xs font-semibold tracking-wide text-cyan-200/90 transition-all duration-300 hover:-translate-y-0.5 hover:border-cyan-300/60 hover:text-cyan-100"
          >
            Register
          </a>
          <button
            data-testid="nav-investor-cta"
            onClick={() => go("investment")}
            className="whitespace-nowrap rounded-md bg-cyan-300 px-4 py-2 text-xs font-bold tracking-wide text-black transition-transform duration-300 hover:-translate-y-0.5 hover:bg-cyan-200"
          >
            Investor Interest
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="text-white xl:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-white/10 bg-black/95 px-6 py-6 backdrop-blur-2xl xl:hidden">
          <div className="flex flex-col gap-4">
            {LINKS.map(([label, id]) => (
              <button
                key={id}
                data-testid={`nav-mobile-link-${id}`}
                onClick={() => go(id)}
                className="py-2 text-left text-sm font-medium text-cyan-200/80 transition-colors hover:text-cyan-100"
              >
                {label}
              </button>
            ))}
            <a
              href="/register"
              data-testid="nav-mobile-register-cta"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-md border border-cyan-300/30 px-4 py-2.5 text-center text-sm font-semibold text-cyan-200/90 transition-colors hover:border-cyan-300/60 hover:text-cyan-100"
            >
              Register for Early Access
            </a>
            <button
              data-testid="nav-mobile-investor-cta"
              onClick={() => go("investment")}
              className="rounded-md bg-cyan-300 px-4 py-2.5 text-sm font-bold text-black"
            >
              Investor Interest
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
